import { createContext, useState, ReactNode, useEffect } from "react";

const defaultValue = {
  accountId: '',
  setAccountId: (newValue: string) => { },
  isConnected: false,
  setIsConnected: (newValue: boolean) => { },
}

export const WalletConnectContext = createContext(defaultValue);

export const WalletConnectContextProvider = (props: { children: ReactNode | undefined }) => {
  const [accountId, setAccountId] = useState(defaultValue.accountId);
  const [isConnected, setIsConnected] = useState(defaultValue.isConnected);

  // Load persisted connection state on mount
  useEffect(() => {
    const persistedAccountId = localStorage.getItem('walletConnect_accountId');
    const persistedIsConnected = localStorage.getItem('walletConnect_isConnected');

    if (persistedAccountId && persistedIsConnected === 'true') {
      setAccountId(persistedAccountId);
      setIsConnected(true);
    }
  }, []);

  // Persist connection state when it changes
  const handleSetAccountId = (newValue: string) => {
    setAccountId(newValue);
    localStorage.setItem('walletConnect_accountId', newValue);
  };

  const handleSetIsConnected = (newValue: boolean) => {
    setIsConnected(newValue);
    localStorage.setItem('walletConnect_isConnected', newValue.toString());

    // Clear account data when disconnecting
    if (!newValue) {
      setAccountId('');
      localStorage.removeItem('walletConnect_accountId');
      localStorage.removeItem('walletConnect_isConnected');
    }
  };

  return (
    <WalletConnectContext.Provider
      value={{
        accountId,
        setAccountId: handleSetAccountId,
        isConnected,
        setIsConnected: handleSetIsConnected
      }}
    >
      {props.children}
    </WalletConnectContext.Provider>
  )
}
